import { introEnter, introLeave } from './intro';
import { sectionsEnter, sectionsLeave } from './sections';
import { resultsEnter, resultsLeave } from './results';

const transitions = new Map();

transitions.set('intro-enter', introEnter);
transitions.set('intro-leave', introLeave);
transitions.set('sections-enter', sectionsEnter);
transitions.set('sections-leave', sectionsLeave);
transitions.set('results-enter', resultsEnter);
transitions.set('results-leave', resultsLeave);

export default transitions;
